// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_mainBlock__zKoAi {
  width: 100%;
  height: max-content;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.styles_wrapper__Sti4S {
  width: calc(100% + var(--SIZE_20));
  height: var(--SIZE_44);
  display: flex;
  align-items: center;
  position: relative;
  right: var(--SIZE_20);
}

.styles_wrapperWarning__2zlXZ {
  width: calc(100% + var(--SIZE_33));
}

.styles_emailIconBlock__AcaoG {
  width: var(--SIZE_20);
  height: var(--SIZE_20);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  position: relative;
  top: var(--SIZE_1);
  left: var(--SIZE_34);
}

.styles_emailInputStyle__aUs2T {
  padding: var(--PADDING_10) var(--PADDING_14) var(--PADDING_10)
    var(--PADDING_42);
  height: var(--SIZE_44);
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_900);
  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);
}

.styles_emailInputStyleWarning__K1VGd {
  border-color: var(--COLOR_FAILED);
}

.styles_warningIconBlock__sK3Ul {
  width: max-content;
  height: max-content;
  display: flex;
  z-index: 1;
  position: relative;
  right: var(--SIZE_25);
}

.styles_warningTextStyle__0sKs9 {
  margin-top: var(--MARGIN_6);
  color: var(--COLOR_ERROR_500);
}
`, "",{"version":3,"sources":["webpack://./src/components/atoms/InputIcon/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;qBACmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,4BAA4B;EAC5B,qEAAqE;AACvE;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B","sourcesContent":[".mainBlock {\n  width: 100%;\n  height: max-content;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.wrapper {\n  width: calc(100% + var(--SIZE_20));\n  height: var(--SIZE_44);\n  display: flex;\n  align-items: center;\n  position: relative;\n  right: var(--SIZE_20);\n}\n\n.wrapperWarning {\n  width: calc(100% + var(--SIZE_33));\n}\n\n.emailIconBlock {\n  width: var(--SIZE_20);\n  height: var(--SIZE_20);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n  position: relative;\n  top: var(--SIZE_1);\n  left: var(--SIZE_34);\n}\n\n.emailInputStyle {\n  padding: var(--PADDING_10) var(--PADDING_14) var(--PADDING_10)\n    var(--PADDING_42);\n  height: var(--SIZE_44);\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_900);\n  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);\n}\n\n.emailInputStyleWarning {\n  border-color: var(--COLOR_FAILED);\n}\n\n.warningIconBlock {\n  width: max-content;\n  height: max-content;\n  display: flex;\n  z-index: 1;\n  position: relative;\n  right: var(--SIZE_25);\n}\n\n.warningTextStyle {\n  margin-top: var(--MARGIN_6);\n  color: var(--COLOR_ERROR_500);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainBlock": `styles_mainBlock__zKoAi`,
	"wrapper": `styles_wrapper__Sti4S`,
	"wrapperWarning": `styles_wrapperWarning__2zlXZ`,
	"emailIconBlock": `styles_emailIconBlock__AcaoG`,
	"emailInputStyle": `styles_emailInputStyle__aUs2T`,
	"emailInputStyleWarning": `styles_emailInputStyleWarning__K1VGd`,
	"warningIconBlock": `styles_warningIconBlock__sK3Ul`,
	"warningTextStyle": `styles_warningTextStyle__0sKs9`
};
export default ___CSS_LOADER_EXPORT___;
